"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSeeInfo = getSeeInfo;
exports.rrwebInit = rrwebInit;

var rrweb = _interopRequireWildcard(require("rrweb"));

var _fetch = _interopRequireDefault(require("./fetch"));

var _tools = require("./tools");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 流程 二期优化方案 节点流程
var lineRegx = {
  starPage: ['/m/short/trial', '/m/short2020/trial', '/short/trial/market'],
  domain: ['https://sky-test.baoinsurance.com', 'https://sky-test.iyunbao.com']
};
var eventsArr = [];
var userAsign = {};
var fetchFlag = true;
var preData = '';
var root = {};

if (typeof window !== 'undefined') {
  root = window;
}

function getStart() {
  rrweb.record({
    emit: function emit(event) {
      eventsArr.push(event);
    }
  });
}

function getSeeInfo() {
  try {
    if ((0, _tools.getParameterByName)('setId')) {
      return {
        setId: (0, _tools.getParameterByName)('setId')
      };
    }

    if (root.userAsign) {
      return root.userAsign;
    }

    if (Object.keys(userAsign).length > 0) {
      return userAsign;
    }

    if (root.localStorage.getItem('userAsign')) {
      return JSON.parse(root.localStorage.getItem('userAsign'));
    }
  } catch (error) {
    console.error('getSeeInfo:', error);
  }
} // 上报


function save() {
  if (!eventsArr.length > 0 && fetchFlag) {
    return false;
  }

  var data = JSON.stringify(_objectSpread({}, eventsArr));
  var loaldata = getSeeInfo();

  if (preData === data) {
    return false;
  }

  if (!Object.keys(loaldata).length > 0) {
    return console.error('report 缺少参数');
  }

  preData = data; // 当前数据给 preData

  eventsArr = [];
  fetchFlag = false;

  _fetch.default.fetch({
    path: '/v1/track/report',
    server: 'hawkeye',
    method: 'POST',
    data: _objectSpread(_objectSpread({
      data: data,
      location: window.location.href
    }, userAsign), loaldata)
  }).then(function (_ref) {
    var code = _ref.code,
        message = _ref.message;

    if (+code === 0) {
      fetchFlag = true;
    } else {
      console.error('report error:', message);
    }
  });
}

function setSeeInfo(data) {
  var obj = data || getSeeInfo();
  root.localStorage.setItem('userAsign', JSON.stringify(obj));
  root.userAsign = obj;
}

function clearSeeInfo() {
  root.localStorage.removeItem('userAsign');
  root.userAsign = {};
}

function createSetId() {
  return _createSetId.apply(this, arguments);
}

function _createSetId() {
  _createSetId = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var MutationObserver, mo, pathname, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // 获取 MutationObserver对象
            MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            mo = new MutationObserver(save);
            pathname = window.location.pathname;
            mo.observe(document.body, {
              childList: true,
              // 子元素的变动
              attributes: true,
              // 属性变动
              characterData: true,
              // 节点内容或节点文本的变动
              subtree: true // 所有下属节点（包括子节点和子节点的子节点）的变动

            }); // 判断不是起始页 就不会创建create

            if (!lineRegx.starPage.includes(pathname)) {
              _context.next = 13;
              break;
            }

            clearSeeInfo();
            _context.next = 8;
            return _fetch.default.fetch({
              path: '/v1/track/create',
              server: 'hawkeye',
              method: 'GET',
              isLoading: true
            });

          case 8:
            response = _context.sent;
            userAsign = response ? response.result : {};

            if (Object.keys(userAsign).length > 0) {
              setSeeInfo(userAsign);
            }

            _context.next = 14;
            break;

          case 13:
            setSeeInfo();

          case 14:
            // 获取 setId 和 aSign
            getStart();

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createSetId.apply(this, arguments);
}

function rrwebInit() {
  createSetId();
}